import { useRef } from 'react';
import { useVoiceState } from './voice/useVoiceState';
import { useVoiceTranscript } from './voice/useVoiceTranscript';
import { useVoiceEvents } from './voice/useVoiceEvents';
import { useVoiceConnection } from './voice/useVoiceConnection';

export function useLawyahVoice(language, { demo = false, scenario = 'enquiry' } = {}) {
  const call = useRef(null);
  const { state, update, resetState, mounted } = useVoiceState();
  const { messages, saveStatus, record, save, resetTranscript } = useVoiceTranscript(call, mounted);
  const { generating, receive } = useVoiceEvents(call, record, update);
  const actions = useVoiceConnection({ call, language, demo, scenario, muted: state.muted,
    update, resetState, receive, generating, save, resetTranscript });
  return { ...state, ...actions, messages, saveStatus, save,
    active: ['requesting', 'connecting', 'connected'].includes(state.status) };
}